module.exports = __webpack_public_path__ + "static/media/maf-52.6f9d0d7c.png";